import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Label,
  Row
} from 'reactstrap';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';


import Botonera from './../components/BotoneraGuardar';
import TablaEstudiantes from './../components/TablaEstudiantes';
import SelectEstudiantes from './../components/SelectEstudiantes'; 
import SelectCiclos from './../components/SelectCiclos'; 
import Estudiante from './../api/Estudiante';

const est = new Estudiante(); 

class GestorEstudiantes extends Component {

  constructor() {
    super();
    this.state = {
      id:'',
      estudiante:'',
      ciclo: '',
      data:[],

      cargando:true,
      validacion:{
          estudiante:false,
          ciclo:false
      },
      confirmarGuardar: false,
      confirmarEditar: false, 
      confirmarBorrar: false,
      idBorrar:'',
      isDisabled:false,

      listaRuts:[],
      editar:'',
      idEditar:''
    }
  }

  estadoDefault = () =>{

    this.setState({
      estudiante:'',
       ciclo:'', 
       id:'',

      validacion:{
        estudiante:false,
        ciclo:false
      },
      confirmarGuardar: false,
      confirmarEditar: false, 
      confirmarBorrar: false,
      idBorrar:'',
      isDisabled:false,
      
      editar:'',
      idEditar:''
      })
  }


  manejaCiclo = (evento) => {
    this.setState({ciclo: evento.target.value})
  }

  manejaEstudiante = (value) => {
    this.setState({estudiante: value});

  }

  cargarListado = async () => {
    let ruts = [];
    let resultado = await est.mostrar(); 
    for (const r in resultado) {
        ruts.push(resultado[r].rut); 
    } 

    this.setState({data: resultado, cargando:false, listaRuts: ruts}); 
  }




  /* funciones comunes para mensajes y validaciones */ 
  guardarEditarValidando = async ({validacion, confirmar}) =>{
      let validado = await validacion();

      if(validado.resultado){
          confirmar()
      }else{

          for (const k in validado.mensajes) {

              this.Notificaciones.addNotification({
                  message: validado.mensajes[k],
                  level: 'error',
                  position:'tr'
              });
               
          }
  
      }  

  }

  mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
      if(resultado==="ok"){

          await this.cargarListado();
          this.estadoDefault();
          
          this.Notificaciones.addNotification({
              title: <FaSave/>,
              message: mensaje,
              level: 'success',
              position:'tr'
          });

      } else{
          this.Notificaciones.addNotification({
              message: 'Error inesperado, intentelo más tarde',
              level: 'error',
              position:'tr'
          });  
      }

      this.setState({cargando:false});   
  }


  validacionFormulario = async () => {
      let {estudiante, ciclo, data, listaRuts, editar} = this.state;
      
      for (const i in data) {
        if (data[i].rut === estudiante.value) {
          this.setState({idEditar:data[i].id })
        }
      } 
     /*let vEstudiante        = validarItem({valor:estudiante, input:'Usuario (estudiante)', vacio:true, repetido:{valor:estudiante.value, arreglo:listaRuts}}); */

 
      let vEstudiante        = editar!=='' ? validarItem({valor:estudiante, input:'Usuario (estudiante)', vacio:true}) : validarItem({valor:estudiante, input:'Usuario (estudiante)', vacio:true, repetido:{valor:estudiante.value, arreglo:listaRuts}});
      let vCiclo             = validarItem({valor:ciclo, input:'Ciclo', select:true});

      if(vEstudiante.respuesta.length>0 && vEstudiante.respuesta[0].validador==='repetido'){
        this.setState({ editar:'repetido', isDisabled:true})
    }

      this.setState({ validacion:{
          estudiante:   !vEstudiante.resultado, 
          ciclo:        !vCiclo.resultado
      } });  
      
      let formulario = validarFormulario([vEstudiante, vCiclo]); 

      return formulario;

  }


  /* ingresar */

  muestraConfirmarGuardar = () => {
    this.setState(prevState => ({
        confirmarGuardar: !prevState.confirmarGuardar
    }));    
  }

  ingresarEstudiante = async () => {
      this.guardarEditarValidando({
          validacion: this.validacionFormulario,
          confirmar: this.muestraConfirmarGuardar   
      }); 
  }

  ingresarEstudianteBD = async () =>{
      this.setState({cargando:true});

      const { estudiante, ciclo} = this.state;                
      let resultado = await est.ingresar(estudiante.value, ciclo); 
      
      this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Estudiante ingresado correctamente'})

  }


    /* editar */

  muestraConfirmarEditar = () => {
    this.setState(prevState => ({
        confirmarEditar: !prevState.confirmarEditar
    }));    
  }

  editarEstudiante = async () => {
      this.guardarEditarValidando({
          validacion: this.validacionFormulario,
          confirmar: this.muestraConfirmarEditar   
      }); 
  }

  editarEstudianteBD = async () =>{
      this.setState({cargando:true});

      let {id, estudiante, ciclo, idEditar} = this.state;

      let idEnviar = id!=='' ? id : idEditar;
      
      let resultado = await est.editar(idEnviar, estudiante.value, ciclo)
      
      this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Estudiante editado correctamente'})

  }

  cargarEditar = (e) => {
    this.setState({
      id: e.id, 
      estudiante: {value: e.rut, label:e.rut+' | '+e.nombres+' ' +e.apellidos}, 
      ciclo: e.ciclo_id, 
      isDisabled:true,
      editar:'editar'
    }); 
} 


    /* borrar */

  muestraConfirmarBorrar = (id) => {
    this.setState((prevState) => ({
        confirmarBorrar: !prevState.confirmarBorrar,
        idBorrar: id
    }));          
  }

  eliminarEstudiante = async () => {
      this.setState({cargando:true});
      
      let resultado = await est.eliminar(this.state.idBorrar)

      if(resultado==="ok"){
          await this.cargarListado();
          
          this.Notificaciones.addNotification({
              title: <FaTrashAlt/>,
              message: 'Estudiante eliminado satisfactoriamente',
              level: 'info',
              position:'tr'
          });
      }else{
          this.Notificaciones.addNotification({
              message: 'Error inesperado, intentelo más tarde',
              level: 'error',
              position:'tr'
          });          
      }

      this.setState({cargando:false});
  }






  componentDidMount() {
    this.cargarListado();
  }

  render(){ 
      const {estudiante, ciclo, data, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion, isDisabled, editar} = this.state; 

      return (
      <Page title="Administrador de estudiantes" breadcrumbs={[ { name: 'Estudiantes', active: true } ]}>
          <Cargando valor={cargando}/>

          <Card>
              <CardHeader>Información del estudiante</CardHeader>
              <CardBody>
              <Form>
  
                  <Row className="no-margin-bottom">


                      <Col  lg={4} md={4} sm={12}>
                          <FormGroup>
                              <Label>Usuario (estudiante)</Label>
                              <SelectEstudiantes maneja={this.manejaEstudiante} estudiante={estudiante} invalido={validacion.estudiante} isDisabled={isDisabled}/>

                          </FormGroup>
                      </Col>

                      <Col  lg={2} md={4} sm={12}>
                          <FormGroup>
                              <Label >Ciclo</Label>
                              <SelectCiclos  maneja={this.manejaCiclo} ciclo={ciclo}  invalido={validacion.ciclo}/>
                          </FormGroup>
                      </Col>


                  </Row>
        
              </Form>
              </CardBody>
              <Botonera 
                    valor={editar}
                    ingresar={this.ingresarEstudiante}
                    editar={this.editarEstudiante}
                    cancelar={this.estadoDefault}
                />
          </Card>


          <br/>


          <TablaEstudiantes 
            data={data} 
            eliminar={this.muestraConfirmarBorrar}
            editar={this.cargarEditar}
          />


        
          <Confirmar 
              isOpen={confirmarGuardar} 
              toggle={this.muestraConfirmarGuardar} 
              texto={"¿Esta seguro de guardar el estudiante?"} 
              funcion={this.ingresarEstudianteBD} 
          />

          <Confirmar 
            isOpen={confirmarEditar} 
            toggle={this.muestraConfirmarEditar} 
            texto={"¿Esta seguro de editar el estudiante?"} 
            funcion={this.editarEstudianteBD} 
          />

          <Confirmar 
            isOpen={confirmarBorrar} 
            toggle={this.muestraConfirmarBorrar} 
            texto={"¿Esta seguro de borrar el estudiante?"} 
            funcion={this.eliminarEstudiante} 
          />


          <Notificaciones
            dismissible={false}
            ref={Notificaciones =>
                (this.Notificaciones = Notificaciones)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        
      </Page>
    )
  }
}

export default GestorEstudiantes;
